import { html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';
import '../katapult-elements/katapult-button.js';
import { FirebaseEncode } from '../../modules/FirebaseEncode';
import '../input-element/input-element.js';

class KatapultArmSpecEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style}
      <style>
        #specSourceLabel {
          position: absolute;
          top: 0;
          right: 0;
          padding: 1.25em 1em;
          font-style: italic;
          color: var(--primary-text-color-faded);
          background: white;
        }
      </style>

      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes/arm_spec" data="{{armSpecs}}">
      </katapult-firebase-worker>

      <template is="dom-if" if="[[itemData.source]]">
        <div id="specSourceLabel">Source: [[itemData.source]]</div>
      </template>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          step$="[[step.id]]"
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <!-- Arm Spec -->
          <template is="dom-if" if="[[equal(step.id, 'arm_spec')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Arm Spec"
                    attribute_name="arm_spec"
                    hide-attribute-name
                    value="[[_itemData.arm_spec]]"
                    data-path="_itemData.arm_spec"
                    on-value-changed="updateProperty"
                    model="[[armSpecs]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>
          <!-- Arm Width -->
          <template is="dom-if" if="[[equal(step.id, 'width')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Arm Width"
                    value="[[_itemData.width]]"
                    data-path="_itemData.width"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Arm Height -->
          <template is="dom-if" if="[[equal(step.id, 'height')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Arm Height"
                    value="[[_itemData.height]]"
                    data-path="_itemData.height"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Arm Depth -->
          <template is="dom-if" if="[[equal(step.id, 'depth')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Arm Depth"
                    value="[[_itemData.depth]]"
                    data-path="_itemData.depth"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Arm Weight -->
          <template is="dom-if" if="[[equal(step.id, 'weight')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Arm Weight"
                    value="[[_itemData.weight]]"
                    data-path="_itemData.weight"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">lbf</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Crossarm Offset -->
          <template is="dom-if" if="[[equal(step.id, 'crossarm_offset')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Crossarm Offset"
                    value="[[_itemData.crossarm_offset]]"
                    data-path="_itemData.crossarm_offset"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">in</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>

          <!-- Position Rating -->
          <template is="dom-if" if="[[equal(step.id, 'position_rating')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    label="Position Rating"
                    value="[[_itemData.position_rating]]"
                    data-path="_itemData.position_rating"
                    on-value-changed="updateProperty"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  >
                    <span slot="suffix">lbs</span>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>
          <!-- Arm Material -->
          <template is="dom-if" if="[[equal(step.id, 'material')]]" restamp>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <input-element
                    label="Arm Material"
                    attribute_name="material"
                    hide-attribute-name
                    value="[[_itemData.material]]"
                    data-path="_itemData.material"
                    on-value-changed="updateProperty"
                    model="[[armMaterials]]"
                    no-label-float
                    disabled="[[!fullyEditable]]"
                  ></input-element>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }
  static get properties() {
    return {
      ...super.properties,
      armMaterials: {
        type: Object,
        value: {
          gui_element: 'dropdown',
          picklists: {
            default: [{ value: 'wood' }, { value: 'steel' }, { value: 'fiberglass' }]
          }
        }
      }
    };
  }

  constructor() {
    super();
    this.computedLabel = {
      dependencies: [{ path: 'arm_spec' }],
      compute: (spec) => spec ?? 'Untitled Arm Spec'
    };
  }

  ready() {
    super.ready();

    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'arm_spec',
        title: 'Arm Spec',
        trigger: () => this.get('_itemData.arm_spec') != null
      },
      {
        id: 'width',
        title: 'Arm Width',
        trigger: () => this.get('_itemData.width') != null
      },
      {
        id: 'height',
        title: 'Arm Height',
        trigger: () => this.get('_itemData.height') != null
      },
      {
        id: 'depth',
        title: 'Arm Depth',
        trigger: () => this.get('_itemData.depth') != null
      },
      {
        id: 'weight',
        title: 'Arm Weight',
        trigger: () => this.get('_itemData.weight') != null
      },
      {
        id: 'crossarm_offset',
        title: 'Crossarm Offset',
        trigger: () => this.get('_itemData.crossarm_offset') != null
      },
      {
        id: 'position_rating',
        title: 'Position Rating',
        trigger: () => this.get('_itemData.position_rating') != null
      },
      {
        id: 'material',
        title: 'Arm Material',
        trigger: () => this.get('_itemData.material') != null
      }
    ]);
  }

  beforeSave() {
    this._itemData.source = `Manual Entry - ${katapultAuth.user.email} (${new Date().toLocaleDateString()})`;
  }
}

customElements.define('katapult-arm-spec-editor', KatapultArmSpecEditor);
